module.exports = __webpack_public_path__ + "media/images/img-secondcarrier-2-467d0d57.jpg";